// This store is used to track whether the LISWP attachment should be shown or not across
// any part of the bundle (mainly, independently mounted React trees).

import { useEffect, useState } from 'react';

// Simple observable implementation - if we start using this in more places we should consider
// a more robust library like RxJS.
const createObservable = <T>(startingValue: T) => {
  let listeners: ((newValue: T) => void)[] = [];
  let value = startingValue;

  const get = () => value;

  const set = (newValue: T) => {
    if (value === newValue) return;
    value = newValue;
    listeners.forEach((l) => l(value));
  };

  const unsubscribe = (listenerFunc: (newValue: T) => void) => {
    listeners = listeners.filter((l) => l !== listenerFunc);
  };

  const subscribe = (listenerFunc: (newValue: T) => void) => {
    listeners.push(listenerFunc);
    return () => unsubscribe(listenerFunc);
  };

  return {
    get,
    set,
    subscribe,
  };
};

export const attachmentShownStore = createObservable(true);

export const useAttachmentShown = () => {
  const [shown, setShown] = useState(attachmentShownStore.get());

  useEffect(() => {
    // Note: Return value is unsubscribe, which will take care of cleanup on unmount
    return attachmentShownStore.subscribe(setShown);
  }, []);

  return shown;
};
